<mat-select [formControl]="ngControl.control" [(value)]="value" [compareWith]="compareColors" disableOptionCentering panelClass="{{ showBMSTheme ? 'bms-theme' : '' }}">
  <mat-select-trigger>
    <div class="container">
      @if (!showBMSTheme) {
        <div class="color-preview" [style.background-color]="getPreviewColorCode(ngControl.value)"></div>
      }
      {{ ngControl.value?.name }}
    </div>
  </mat-select-trigger>
  @for (color of colors; track color) {
    <mat-option [attr.value]="color" [value]="color">
      <div class="container">
        @if (!showBMSTheme) {
          <div class="color-preview" [style.background-color]="getPreviewColorCode(color)"></div>
        }
        {{ color?.name }}
      </div>
    </mat-option>
  }
</mat-select>
